import { Button, Input, Select, Spin, Table } from 'antd';
import "aos/dist/aos.css";
import { Option } from "antd/es/mentions";
import React, { useState ,useEffect } from 'react'
// import "../../MainCSS.css";
import axios from 'axios';
import { toast } from 'react-toastify';

import { DieNameMasterGet } from '../../AllAPI/MasterAPI/DiesMasterApi';
import { GetStockCheckingData, StockCheckingExcelReport } from '../../AllAPI/SalesAPI/SalesApi';
import { FaFileExcel } from 'react-icons/fa6';
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi';

const StockChecking = () =>{
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };

    const [errors, setErrors] = useState({
    itemName: "",
      allocate: "",
  
    });
        const [loading, setLoading] = useState(false);
  
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [itemNameId, setItemNameId] = useState("");
    const [itemName, setItemName] = useState("");
    const [allocate, setAllocate] = useState("");
  
    const [allDieName, setAllDieName] = useState([]);
    const[allStockCheck,setAllStockCheck]=useState([]);
    const [submitButton, setSubmitButton] = useState(true);
    const [updateButton, setUpdateButton] = useState(false);
  
    //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
    
      const filtered = allStockCheck.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );
    
      setFilteredData(filtered);
      setTotalEntries(filtered.length);
      setCurrentPage(1);
    };
  
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };
  
    // ==============Get table data================
  let isStockCheckMasterFetched = false;
  useEffect(() => {
    if (isStockCheckMasterFetched) return;
        fetchDieNameMaster();
    isStockCheckMasterFetched = true;
  }, []);

  let isError = false;

  const fetchDieNameMaster = async () => {
    try {
      const response = await axios.get(DieNameMasterGet ,commonHeaders);
      if (response.data !== null) {
        setAllDieName(response.data);
       
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Die Category Master data:", error);
        toast.error("Failed to fetch Die Category Master data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };
  
  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => index + 1,
  },
   {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => {
      const descA = a.packingId || '';
      const descB = b.packingId || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => {
      const descA = a.dieName || '';
      const descB = b.dieName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => {
      const descA = a.alloyName || '';
      const descB = b.alloyName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Temper',
    dataIndex: 'temper',
    key: 'temper',
    sorter: (a, b) => {
      const descA = a.temperName || '';
      const descB = b.temperName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Wt/R',
    dataIndex: 'weightRange',
    key: 'weightRange',
    sorter: (a, b) => {
      const descA = a.weightRange || '';
      const descB = b.weightRange || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => {
      const descA = a.pcs ?? 0;
      const descB = b.pcs ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Qty',
    dataIndex: 'netWeight',
    key: 'netWeight',
    sorter: (a, b) => {
      const descA = a.netWeight ?? 0;
      const descB = b.netWeight ?? 0;
      return descA - descB;
    },
  },
...(allocate === "1" || allocate === "2"
  ? [{
      title: 'Customer Name',
      dataIndex: 'customerName',
      key: 'customerName',
      render: (_, record) => record.customerName || '',
      sorter: (a, b) => {
        const nameA = a.customerName || '';
        const nameB = b.customerName || '';
        return nameA.localeCompare(nameB);
      },
    }]
  : []),

  {
    title: 'Order No.',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    sorter: (a, b) => {
      const descA = a.orderNumber || '';
      const descB = b.orderNumber || '';
      return descA.localeCompare(descB);
    },
  },
];

  
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#023e7d",
              color: "#fff",
              padding: "10px",
      fontSize: '15px',
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
                    fontSize: '15px',

            }}
          >
            {children}
          </td>
        ),
      },
    };
    // ========Submit data to table==============
        const handleSubmit = async () => {
          let isValid = true;
          const errorObj = {};
      
          
          if (!allocate.trim()) {
            isValid = false;
            errorObj.allocate = "Type is required *";
          }
      
      
          setErrors(errorObj); // Set error messages
      
          if (!isValid) return;
      
         
      
          try {
            //  const response = await axios.get(`${GetStockCheckingData}?allocation=${allocate}&dieNameId=${itemName}`,commonHeaders);
                // Check if allocate is not equal to '1' before passing it to the API
    const url = allocate === "3" 
      ? `${GetStockCheckingData}?dieNameId=${itemName}`  // Do not pass allocate if it is 1
      : `${GetStockCheckingData}?allocation=${allocate}&dieNameId=${itemName}`; // Pass allocation if it's not 1

    const response = await axios.get(url, commonHeaders);

       const stockDetails = response.data
      
            if (!stockDetails) {
              toast.error('Failed to fetch order details.')
              return
            }
      
          if (Array.isArray(stockDetails) && stockDetails.length > 0) {
          
                 setAllStockCheck(response.data);
               setFilteredData(response.data); // Set initial filtered data as the fetched data
               setTotalEntries(response.data.length); // Set the total number of entries
          
     
            }else {
                    toast.warn('No items found for the selected order.')
                    setAllStockCheck([]) // Clear order items
                    setFilteredData([]) // Clear filtered data (this will reset the table display)
                    setTotalEntries(0) // Reset total entries count
                  }
          } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while submitting data");
          }
        };
              const handleReport = async () => {
    
            
                try {
                // const response = await axios.get(`${StockCheckingExcelReport}?allocation=${allocate}&dieNameId=${itemName}` ,commonHeaders);      
                  const url = allocate === "3"
      ? `${StockCheckingExcelReport}?dieNameId=${itemName}` // Do not pass allocation if it is 1
      : `${StockCheckingExcelReport}?allocation=${allocate}&dieNameId=${itemName}`; // Pass allocation if it's not 1
          const response = await axios.get(url, commonHeaders);

                  if (response.data !== null) {
                    if (response.data === "NOTFOUND" || response.data === "NODATA" || response.status === 204) {
                      toast.warn("No data available!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                   
                      setLoading(false);
                      return; // Exit function early
                    }
          
                    let reportUrl = response.data;
                    console.log("Response data:", response.data);
                    if (reportUrl === "FILENOTFOUND") {
                      toast.warn("Jrxml File Not Found...!!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                    } 
                   else if (reportUrl === "NOTFOUND") {
                      toast.warn("Report File Not Found...!!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      });
                    } else {
                      const reportLink =  BaseIPForPDF + `output/${reportUrl}`;
                      window.open(reportLink, "_blank");
                    }
                  }
                } catch (error) {
                  setLoading(false);
                  console.error("Error during API call:", error);
                  toast.error("Error occurred while submitting data");
                }
            
             
            
              };
    
   
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">

  <Spin
  spinning={loading}
  tip={<span style={{ fontSize: "20px", fontWeight: "500" }}>Generating Excel...</span>}
></Spin>
    <div className="p-0 m-0">
        <div className="row px-md-5 mt-3 p-2 ">
   
   <div className="row p-0 m-0">
   <div className="col-12 col-lg-4"></div>
   <div className="col-12 col-lg-4">
   <div className="row p-0 m-0">
     
          <div className="col-12 py-1">
            <label className="labels">Item Name</label>
             <Select
                           value={itemName || undefined}
                           onChange={setItemName}
                           showSearch
                           className="w-100"
                           placeholder="Select Name"
                           optionFilterProp="children"
                         >
                           {allDieName.map((item) => (
                             <Option key={item.id} value={item.id}>
                               {item.dieName}
                             </Option>
                           ))}
                         </Select>
                         {errors.itemName && (
                           <div className="errorField">{errors.itemName}</div>
                         )}
                         </div>  
    
        <div className="col-12 py-1">
  <label className="labels">Allocation Type</label>
  <Select
    value={allocate || undefined}
     showSearch
    onChange={(value) => setAllocate(value)}
    placeholder="Select Allocate"
     optionFilterProp="children"
    style={{ width: '100%' }}
  >
    <Option value ="3" >All</Option>
    <Option value="1">Allocated</Option>
   <Option value="2">Unallocated</Option>
  </Select>
  {errors.allocate && <div className="errorField">{errors.allocate}</div>}
</div>
          </div>
          </div>
          </div>
      
          
              <div className="col-12 text-center pt-3">
             
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                     onClick={handleSubmit}
                  >
                    Show
                  </Button>
               
              
              </div>
      
         
      
        <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div></div>
      
        {/*================ Table =========================*/}
        <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
          <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
            <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                <Select
                  defaultValue={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: 120, textAlign: "center" }}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                </Select>
              </div>
      
              <div className="pt-4 pt-md-0">
                    <Button
                                                                           type="submit"
                                                                           onClick={() => handleReport()}
                                                                           style={{
                                                                             width:60,
                                                                             marginBottom: 16,
                                                                             color: 'white',
                                                                             backgroundColor: '#2E86C1',
                                                                             gap:4,
                                                                      marginRight:10,
                                                                      alignItems:'center',
                                                                             padding:0
                                                                           }}
                                                                           disabled={loading}
                                                                         >
                                                                           <FaFileExcel style={{  fontSize: '18px', color: 'white' }} />
                                                                           Excel
                                                                         </Button>
                <Input.Search
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 200, marginBottom: 16 }}
                />
              </div>
            </div>
      
            <div style={{ backgroundColor: "white" }}>
              <Table
                bordered
                style={{ padding: "0px 20px", overflowX: "auto" }}
                columns={columns}
                dataSource={filteredData}
                pagination={{
                  pageSize: pageSize,
                  total: totalEntries,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  current: currentPage,
                  onChange: (page) => setCurrentPage(page),
                }}
                showSorterTooltip={false}
                rowKey={(record) => record.id}
                components={components}
              />
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
      </div>
  )
}

export default StockChecking